import { useTranslation } from "react-i18next";

export const FootMenu = (props: any) => {
  const { t } = useTranslation()
  return (
    <footer className="footmenu d-flex justify-content-around p-2">
      <a href="/home.html" className="menu"><span className="material-icons-outlined menuicon">cottage</span>
        <div className="menutxt">{t('home')}</div>
      </a>
      <a href="/app/wallet" className="menu cursor-pointer"><span className="material-icons-outlined menuicon">paid</span>
        <div className="menutxt">{t('wallet')}</div>
      </a>
      <a href="/team.html" className="menu"><span className="material-icons-outlined menuicon">groups</span>
        <div className="menutxt">{t('team')}</div>
      </a>
      <a href="/my.html" className="menu">
        <span className="material-icons-outlined menuicon">account_circle</span>
        <div className="menutxt">{t('my')}</div>
      </a>
    </footer>
  )
}
